import React from 'react';

export default function Header() {
  return (
    <header className="header">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img src="/kconnect-logo.jpg" alt="Kairon Connect" className="h-12 w-auto" />
          <div>
            <h1 className="text-lg font-bold text-gray-900">Kairon Connect</h1>
            <p className="text-xs text-gray-500">Workflow Automation Engine</p>
          </div>
        </div>
        <p className="text-xs text-gray-500">Powered by Activepieces</p>
      </div>
    </header>
  );
}
